import styled from 'styled-components';

export const nameStyle = {
  width: '100%',
};

export const FormContainer = styled.div`
  display: flex;
  height: 60vh;
  flex-direction: column;
  justify-content: space-between;
`;

export const toolTipStyle = {
  fontWeight: 'bold',
};

export default {
  FormContainer,
  nameStyle,
  toolTipStyle,
};
